<template>
  <div>
    <MainHead></MainHead>
    <router-view></router-view>
    <MainFooter></MainFooter>

  </div>
</template>

<script>
  import MainHead from './Head'
  import MainFooter from './Footer'
  export default {
    name: "Layout",
    components : {
      MainHead,
      MainFooter
    }
  }
</script>




// WEBPACK FOOTER //
// Layout.vue?0ca57c2e